import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

interface SendFlyerButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  size?: 'small' | 'medium' | 'large';
  variant?: 'text' | 'outlined' | 'contained';
  fullWidth?: boolean;
  label?: string;
}

export const SendFlyerButton: React.FC<SendFlyerButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
  size = 'small',
  variant = 'outlined',
  fullWidth = false,
  label = 'Send Flyer',
}) => {
  return (
    <Button
      size={size}
      color="primary"
      variant={variant}
      onClick={onClick}
      disabled={disabled || isLoading}
      fullWidth={fullWidth}
      startIcon={isLoading ? <CircularProgress size={16} /> : <SendIcon />}
    >
      {label}
    </Button>
  );
};
